import {css} from '@emotion/react'
import {useStaticQuery, graphql} from 'gatsby'

const translations = {
    en: {
        title: 'Anonymous Access to Top AI Models',
        description:
            'Chat with the latest AI models without any data collection or tracking. Your conversations remain completely private and secure.',
    },
    de: {
        title: 'Anonymer Zugang zu Top-KI-Modellen',
        description:
            'Chatten Sie mit den neuesten KI-Modellen ohne Datensammlung oder Tracking. Ihre Gespräche bleiben vollständig privat und sicher.',
    },
    nl: {
        title: 'Anonieme toegang tot Top AI-modellen',
        description:
            'Chat met de nieuwste AI-modellen zonder gegevensverzameling of tracking. Uw gesprekken blijven volledig privé en veilig.',
    },
}

// eslint-disable-next-line no-unused-vars
const Section2 = ({languageCode = 'en', experimentId, os, browser}) => {
    const text = translations[languageCode] || translations.en

    const images = useStaticQuery(graphql`
        query PrivateAISection2Images {
            modelPhone: file(relativePath: {eq: "startpage/phones/app-model.png"}) {
                publicURL
            }
        }
    `)

    return (
        <section
            className="sp-section2"
            css={css`
                width: 100%;
                height: 619px;
                background: linear-gradient(180deg, #222B72 0%, #070707 100%);
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                padding: 0px 20px 0;
                box-sizing: border-box;
            `}
        >
            <div
                className="content-wrapper"
                css={css`
                    max-width: 400px;
                    width: 100%;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    flex: 1;
                    justify-content: center;
                `}
            >
                <h2
                    css={css`
                        color: #F2F3FB;
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: 'Inter';
                        font-size: 32px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 40px;
                        letter-spacing: 0.5px;
                        margin-bottom: 20px;
                    `}
                >
                    {text.title}
                </h2>

                <p
                    css={css`
                        color: #EBECF7;
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: 'Inter';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                        letter-spacing: 0.048px;
                        margin: 0 0 15px 0;
                        max-width: 320px;
                    `}
                >
                    {text.description}
                </p>
            </div>

            {/* Phone Mockup - Positioned at bottom */}
            <div
                className="phone-mockup"
                css={css`
                    display: flex;
                    justify-content: center;
                    flex-shrink: 0;
                `}
            >
                <img
                    src={images.modelPhone.publicURL}
                    alt="A smartphone screen of the Private AI chat app"
                    loading="eager"
                    css={css`
                        width: 100%;
                        height: auto;
                        max-width: 280px;
                        filter: drop-shadow(0 15px 40px rgba(0, 0, 0, 0.4));
                    `}
                />
            </div>
        </section>
    )
}

export default Section2
